import { z } from 'zod';
import { Platform } from '../types';

export const addressableSchema = z.object({
	platform: z.nativeEnum(Platform, { message: 'Platform is required' }),
	version: z.string().regex(/^\d+\.\d+\.\d+$/, 'Version must be in x.x.x format'),
	buildNumber: z.string().refine((val) => /^\d+$/.test(val) && Number(val) >= 1, {
		message: 'Build number must be a number and at least 1',
	}),
});
